"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputService = void 0;
const __1 = require("../");
const event_context_1 = require("./event.context");
const event_info_1 = require("./event.info");
class InputService {
    constructor() {
        this.__priority = 100;
        this.isDebug = true;
        this.currentModifiers = { ctrl: false, shift: false, alt: false, meta: false };
        this.events = new Map();
        this.bound = false;
    }
    init() {
        if (this.bound) {
            return;
        }
        this.bound = true;
        const $window = __1.Services.Window.window;
        $window.document.addEventListener('keydown', this.onKeyDown.bind(this));
        $window.document.addEventListener('keyup', this.onKeyUp.bind(this));
        $window.addEventListener('focus', this.onWindowFocus.bind(this));
    }
    getContext() {
        return new event_context_1.InputEventBindContext(this);
    }
    onKeyDown(evt) {
        const code = evt.code;
        this.setModifiers(evt);
        const eventDescriptor = {
            code,
            modifiers: this.currentModifiers,
            eventType: 'keydown',
        };
        this.emit(eventDescriptor, evt);
    }
    onKeyUp(evt) {
        const code = evt.code;
        this.setModifiers(evt);
        const eventDescriptor = {
            code,
            modifiers: this.currentModifiers,
            eventType: 'keyup',
        };
        this.emit(eventDescriptor, evt);
    }
    /** Reset the current modifiers on window focus */
    onWindowFocus() {
        this.currentModifiers = { ctrl: false, shift: false, alt: false, meta: false };
    }
    on(ctx, eventDescriptor, callback) {
        const eventSymbol = Symbol();
        this.events.set(eventSymbol, new event_info_1.InputEventInfo(eventDescriptor, callback));
        return eventSymbol;
    }
    off(ctx, symbol) {
        return this.events.delete(symbol);
    }
    emit(eventDescriptor, evt) {
        this.events.forEach((event) => {
            if (event.shouldTrigger(eventDescriptor)) {
                const eventData = {
                    event: evt,
                    descriptor: eventDescriptor,
                };
                event.callback(eventData);
            }
        });
    }
    setModifiers(evt) {
        this.currentModifiers = {
            ctrl: evt.ctrlKey,
            shift: evt.shiftKey,
            alt: evt.altKey,
            meta: evt.metaKey,
        };
    }
}
exports.InputService = InputService;
//# sourceMappingURL=input.service.js.map